import React, { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import FeeManagement from './FeeManagement';
import OtherFeeManagement from './OtherFeeManagement';

const StudentFeeTabs = () => {
  const [tabIndex, setTabIndex] = useState(0);

  return (
    <Box 
      sx={{ 
        p: { xs: 1, sm: 2 }, // padding छोटा mobile पर, बड़ा desktop पर
        width: "100%",
        overflowX: "hidden" 
      }}
    >
      {/* Responsive Tabs */}
      <Tabs
        value={tabIndex}
        onChange={(_, newVal) => setTabIndex(newVal)}
        variant="scrollable"   // scrollable बनाओ mobile में
        scrollButtons
        allowScrollButtonsMobile
        sx={{
          borderBottom: 1,
          borderColor: "divider",
          minHeight: { xs: 40, sm: 48 }
        }}
      >
        <Tab label="Student Fee List" sx={{ fontSize: { xs: "0.75rem", sm: "0.9rem" } }} />
        <Tab label="Miscellaneous Fee List" sx={{ fontSize: { xs: "0.75rem", sm: "0.9rem" } }} />
      </Tabs>

      {/* Tab Content */}
      <Box mt={2} sx={{ width: "100%", overflowX: "auto" }}>
        {tabIndex === 0 && <FeeManagement />}
        {tabIndex === 1 && <OtherFeeManagement />}
      </Box>
    </Box>
  );
};

export default StudentFeeTabs;
